<div class="d-flex align-content-center h-100">
  <label class="me-2 text label-custom" [ngClass]="{ 'not-checked': toggleControl.value }" translate>{{ leftText }}</label>
  <mat-slide-toggle class="alert-credit__toggle" [formControl]="toggleControl"> </mat-slide-toggle>
  <label
    class="ms-2 text label-custom"
    [ngClass]="{ 'not-checked': !toggleControl.value, 'checked-right': toggleControl.value }"
    translate
    >{{ rightText }}</label
  >
</div>
